const surahs = [
  {
    name: 'Fatiha',
    page: 0,
    keywords: 'Fatiha, Elfatiha, fatiha',
    index: 1,
    numberOfAyahs: 7,
  },
  {
    name: 'Bakara',
    page: 1,
    keywords: 'Bakara, inek, elbakara',
    index: 2,
    numberOfAyahs: 286,
  },
  {
    name: 'Âl-i İmran',
    page: 49,
    keywords: 'Âl-i İmran, ali imran, Imran, Ali, İmran',
    index: 3,
    numberOfAyahs: 200,
  },
  {
    name: 'Nisâ',
    page: 76,
    keywords: 'Nisa, Nisâ, nisa',
    index: 4,
    numberOfAyahs: 176,
  },
  {
    name: 'Mâide',
    page: 105,
    keywords: 'Mâide, maide',
    index: 5,
    numberOfAyahs: 120,
  },
  {
    name: "En'am",
    page: 127,
    keywords: "En'am, enam",
    index: 6,
    numberOfAyahs: 165,
  },
  {
    name: "A'raf",
    page: 150,
    keywords: "A'raf, araf",
    index: 7,
    numberOfAyahs: 206,
  },
  { name: 'Enfal', page: 176, keywords: 'Enfal', index: 8, numberOfAyahs: 75 },
  {
    name: 'Tevbe',
    page: 186,
    keywords: 'Tevbe, tovbe, tövbe',
    index: 9,
    numberOfAyahs: 129,
  },
  {
    name: 'Yunus',
    page: 207,
    keywords: 'Yunus , yûnus,',
    index: 10,
    numberOfAyahs: 109,
  },
  {
    name: 'Hûd',
    page: 220,
    keywords: 'hud, hüd, Hûd',
    index: 11,
    numberOfAyahs: 123,
  },
  {
    name: 'Yûsuf',
    page: 234,
    keywords: 'Yûsuf , yusuf',
    index: 12,
    numberOfAyahs: 111,
  },
  {
    name: "Ra'd",
    page: 248,
    keywords: "rad, Ra'd",
    index: 13,
    numberOfAyahs: 43,
  },
  {
    name: 'İbrâhim (a.s)',
    page: 254,
    keywords: 'ibrahim, Ibrahim, ıbrahım, ibrahim',
    index: 14,
    numberOfAyahs: 52,
  },
  {
    name: 'Hicr',
    page: 261,
    keywords: 'Hicr hicr hicr',
    index: 15,
    numberOfAyahs: 99,
  },
  {
    name: 'Nahl',
    page: 266,
    keywords: 'Nahl, nahil',
    index: 16,
    numberOfAyahs: 128,
  },
  {
    name: 'İsrâ',
    page: 281,
    keywords: 'İsrâ, isra, Isra',
    index: 17,
    numberOfAyahs: 111,
  },
  {
    name: 'Kehf',
    page: 292,
    keywords: 'Kehf, kahf',
    index: 18,
    numberOfAyahs: 110,
  },
  {
    name: 'Meryem',
    page: 304,
    keywords: 'Meryem, maryam',
    index: 19,
    numberOfAyahs: 98,
  },
  {
    name: 'Tâ-Hâ',
    page: 311,
    keywords: 'Tâ-Hâ, taha, tâha',
    index: 20,
    numberOfAyahs: 135,
  },
  {
    name: 'Enbiya',
    page: 321,
    keywords: 'Enbiya, embiya, enbia',
    index: 21,
    numberOfAyahs: 112,
  },
  {
    name: 'Hac',
    page: 331,
    keywords: 'Hac, haj',
    index: 22,
    numberOfAyahs: 78,
  },
  {
    name: "Mü'minûn",
    page: 341,
    keywords: "Mü'minûn, muminun müminun",
    index: 23,
    numberOfAyahs: 118,
  },
  {
    name: 'Nûr',
    page: 349,
    keywords: 'Nûr, nur',
    index: 24,
    numberOfAyahs: 64,
  },
  {
    name: 'Furkan',
    page: 358,
    keywords: 'Furkan, furqan',
    index: 25,
    numberOfAyahs: 77,
  },
  {
    name: 'Şuarâ',
    page: 366,
    keywords: 'Şuarâ, suara',
    index: 26,
    numberOfAyahs: 227,
  },
  {
    name: 'Neml',
    page: 376,
    keywords: 'Neml, nemil',
    index: 27,
    numberOfAyahs: 93,
  },
  {
    name: 'Kasas',
    page: 384,
    keywords: 'Kasas, qasas kisas, kısas',
    index: 28,
    numberOfAyahs: 88,
  },
  {
    name: 'Ankebût',
    page: 395,
    keywords: 'Ankebût, ankebut örümcek',
    index: 29,
    numberOfAyahs: 69,
  },
  {
    name: 'Rûm',
    page: 403,
    keywords: 'Rûm, rum',
    index: 30,
    numberOfAyahs: 60,
  },
  {
    name: 'Lokman',
    page: 410,
    keywords: 'Lokman, loqman',
    index: 31,
    numberOfAyahs: 34,
  },
  {
    name: 'Secde',
    page: 414,
    keywords: 'Secde, sejde',
    index: 32,
    numberOfAyahs: 30,
  },
  {
    name: 'Ahzâb',
    page: 417,
    keywords: 'Ahzâb, ahzab, ahzap',
    index: 33,
    numberOfAyahs: 73,
  },
  {
    name: "Sebe'",
    page: 427,
    keywords: "Sebe' ",
    index: 34,
    numberOfAyahs: 54,
  },
  {
    name: 'Fâtır',
    page: 433,
    keywords: 'Fâtır, fatr, Fatır, fatir',
    index: 35,
    numberOfAyahs: 45,
  },
  {
    name: 'Yâsin',
    page: 439,
    keywords: 'Yâsin, yasin',
    index: 36,
    numberOfAyahs: 83,
  },
  {
    name: 'Sâffât',
    page: 445,
    keywords: 'Sâffât, saffat, safat',
    index: 37,
    numberOfAyahs: 182,
  },
  {
    name: 'Sâd',
    page: 452,
    keywords: "Sâd, sad, sa'd",
    index: 38,
    numberOfAyahs: 88,
  },
  {
    name: 'Zümer',
    page: 457,
    keywords: 'Zümer, zumer, zumar',
    index: 39,
    numberOfAyahs: 75,
  },
  {
    name: "Mü'min",
    page: 466,
    keywords: "Mü'min, mumin, Mümin",
    index: 40,
    numberOfAyahs: 85,
  },
  {
    name: 'Fussilet',
    page: 476,
    keywords: 'Fussilet, fusilet',
    index: 41,
    numberOfAyahs: 54,
  },
  {
    name: 'Şûrâ',
    page: 482,
    keywords: 'Şûrâ,Şûra, sura',
    index: 42,
    numberOfAyahs: 53,
  },
  {
    name: 'Zuhruf',
    page: 488,
    keywords: 'Zuhruf',
    index: 43,
    numberOfAyahs: 89,
  },
  {
    name: 'Duhân',
    page: 495,
    keywords: 'Duhân, duhan',
    index: 44,
    numberOfAyahs: 59,
  },
  {
    name: 'Casiye',
    page: 498,
    keywords: 'Casiye',
    index: 45,
    numberOfAyahs: 37,
  },
  { name: 'Ahkaf', page: 501, keywords: 'Ahkaf', index: 46, numberOfAyahs: 35 },
  {
    name: 'Muhammed',
    page: 506,
    keywords: 'Muhammed, muhammet, mohammad',
    index: 47,
    numberOfAyahs: 38,
  },
  {
    name: 'Feth',
    page: 510,
    keywords: 'Feth, fetih',
    index: 48,
    numberOfAyahs: 29,
  },
  {
    name: 'Hucurat',
    page: 514,
    keywords: 'Hucurat, hücurat',
    index: 49,
    numberOfAyahs: 18,
  },
  {
    name: 'Kaf',
    page: 517,
    keywords: 'Kaf, kâf',
    index: 50,
    numberOfAyahs: 45,
  },
  {
    name: 'Zâriyât',
    page: 519,
    keywords: 'Zâriyât, zariat, zariyat',
    index: 51,
    numberOfAyahs: 60,
  },
  {
    name: 'Tûr',
    page: 522,
    keywords: 'Tûr, tur',
    index: 52,
    numberOfAyahs: 49,
  },
  {
    name: 'Necm',
    page: 525,
    keywords: 'Necm, necim,',
    index: 53,
    numberOfAyahs: 62,
  },
  {
    name: 'Kamer',
    page: 527,
    keywords: 'Kamer, kamar, qamer',
    index: 54,
    numberOfAyahs: 55,
  },
  {
    name: 'Rahmân',
    page: 530,
    keywords: 'Rahman, Rahmân, rah, rahman, sarahman',
    index: 55,
    numberOfAyahs: 78,
  },
  {
    name: 'Vâkıa',
    page: 533,
    keywords: 'Vâkıa, vakia, vakıa',
    index: 56,
    numberOfAyahs: 96,
  },
  {
    name: 'Hadid',
    page: 536,
    keywords: 'Hadid, hadit',
    index: 57,
    numberOfAyahs: 29,
  },
  {
    name: 'Mücâdele',
    page: 541,
    keywords: 'Mücâdele, mucadele',
    index: 58,
    numberOfAyahs: 22,
  },
  {
    name: 'Haşr',
    page: 544,
    keywords: 'Haşr, hasr',
    index: 59,
    numberOfAyahs: 24,
  },
  {
    name: 'Mümtehine',
    page: 548,
    keywords: 'Mümtehine, mumtehine',
    index: 60,
    numberOfAyahs: 13,
  },
  {
    name: 'Saf',
    page: 550,
    keywords: 'Saf, saff',
    index: 61,
    numberOfAyahs: 14,
  },
  {
    name: 'Cumua',
    page: 552,
    keywords: 'Cumua, cuma, cumuah',
    index: 62,
    numberOfAyahs: 11,
  },
  {
    name: 'Münafikun',
    page: 553,
    keywords: 'Münafikun, münafıkun, munafikunö munafıkun',
    index: 63,
    numberOfAyahs: 11,
  },
  {
    name: 'Tegâbün',
    page: 555,
    keywords: 'Tegâbün, tegabun, tegabûn',
    index: 64,
    numberOfAyahs: 18,
  },
  {
    name: 'Talak',
    page: 557,
    keywords: 'Talak, talâk',
    index: 65,
    numberOfAyahs: 12,
  },
  {
    name: 'Tahrim',
    page: 559,
    keywords: 'Tahrim, tahrım',
    index: 66,
    numberOfAyahs: 12,
  },
  {
    name: 'Mülk',
    page: 561,
    keywords: 'Mülk, mulk',
    index: 67,
    numberOfAyahs: 30,
  },
  {
    name: 'Kalem',
    page: 563,
    keywords: 'Kalem, qalem',
    index: 68,
    numberOfAyahs: 52,
  },
  {
    name: 'Hakka',
    page: 565,
    keywords: 'Hakka, hakkah, haqqah',
    index: 69,
    numberOfAyahs: 52,
  },
  {
    name: 'Meâric',
    page: 567,
    keywords: 'Meâric, mearıc, maaric, meariç',
    index: 70,
    numberOfAyahs: 44,
  },
  {
    name: 'Nûh',
    page: 569,
    keywords: 'Nûh, nuh',
    index: 71,
    numberOfAyahs: 28,
  },
  {
    name: 'Cin',
    page: 571,
    keywords: 'Cin, cın, cinn',
    index: 72,
    numberOfAyahs: 28,
  },
  {
    name: 'Müzzemmil',
    page: 573,
    keywords: 'Müzzemmil, müzemmil, muzzemmil',
    index: 73,
    numberOfAyahs: 20,
  },
  {
    name: 'Müddessir',
    page: 574,
    keywords: 'Müddessir, müdessir, mudessir, muddessir',
    index: 74,
    numberOfAyahs: 56,
  },
  {
    name: 'Kıyamet',
    page: 576,
    keywords: 'Kıyamet, kiyamet, qıyamah',
    index: 75,
    numberOfAyahs: 40,
  },
  {
    name: 'İnsan',
    page: 577,
    keywords: 'İnsan, insan, ınsan',
    index: 76,
    numberOfAyahs: 31,
  },
  {
    name: 'Mürselât',
    page: 579,
    keywords: 'Mürselât, mürselat, murselat',
    index: 77,
    numberOfAyahs: 50,
  },
  { name: "Nebe'", page: 581, keywords: "Nebe'", index: 78, numberOfAyahs: 40 },
  {
    name: 'Naziât',
    page: 582,
    keywords: 'Naziât, nazıat, naziat',
    index: 79,
    numberOfAyahs: 46,
  },
  { name: 'Abese', page: 584, keywords: 'Abese', index: 80, numberOfAyahs: 42 },
  {
    name: 'Tekvir',
    page: 585,
    keywords: 'Tekvir',
    index: 81,
    numberOfAyahs: 29,
  },
  {
    name: 'İnfitar',
    page: 586,
    keywords: 'İnfitar, Infıtar, infitar',
    index: 82,
    numberOfAyahs: 19,
  },
  {
    name: 'Mutaffifîn',
    page: 587,
    keywords: 'Mutaffifîn, mutaffifiin, mütaffifin',
    index: 83,
    numberOfAyahs: 36,
  },
  {
    name: 'İnşikak',
    page: 588,
    keywords: 'İnşikak, inşikak',
    index: 84,
    numberOfAyahs: 25,
  },
  {
    name: 'Bürûc',
    page: 589,
    keywords: 'Bürûc, büruç, buruc, buruç',
    index: 85,
    numberOfAyahs: 22,
  },
  {
    name: 'Târık',
    page: 590,
    keywords: 'Târık, tarık, tarik',
    index: 86,
    numberOfAyahs: 17,
  },
  {
    name: "A'lâ",
    page: 591,
    keywords: "Ala, A'lâ, A'la",
    index: 87,
    numberOfAyahs: 19,
  },
  {
    name: 'Gâşiye',
    page: 591,
    keywords: 'Gâşiye, gasiye, gaşiye',
    index: 88,
    numberOfAyahs: 26,
  },
  {
    name: 'Fecr',
    page: 592,
    keywords: 'Fecr, fecir',
    index: 89,
    numberOfAyahs: 30,
  },
  {
    name: 'Beled',
    page: 593,
    keywords: 'Beled, belet',
    index: 90,
    numberOfAyahs: 20,
  },
  {
    name: 'Şems',
    page: 594,
    keywords: 'Şems, sems',
    index: 91,
    numberOfAyahs: 15,
  },
  {
    name: 'Leyl',
    page: 595,
    keywords: 'Leyl, layl',
    index: 92,
    numberOfAyahs: 21,
  },
  {
    name: 'Duhâ',
    page: 595,
    keywords: 'Duhâ, duha',
    index: 93,
    numberOfAyahs: 11,
  },
  {
    name: 'İnşirah',
    page: 596,
    keywords: 'İnşirah, inşirah, ınsırah, insirah',
    index: 94,
    numberOfAyahs: 8,
  },
  {
    name: 'Tin',
    page: 596,
    keywords: 'Tin, tın, zeytin',
    index: 95,
    numberOfAyahs: 8,
  },
  { name: 'Alak', page: 597, keywords: 'Alak', index: 96, numberOfAyahs: 19 },
  {
    name: 'Kadir',
    page: 598,
    keywords: 'Kadir, kadr',
    index: 97,
    numberOfAyahs: 5,
  },
  {
    name: 'Beyyine',
    page: 598,
    keywords: 'Beyyine, beyyineh',
    index: 98,
    numberOfAyahs: 8,
  },
  {
    name: 'Zilzal',
    page: 599,
    keywords: 'Zilzal, zılzal',
    index: 99,
    numberOfAyahs: 8,
  },
  {
    name: 'Âdiyât',
    page: 599,
    keywords: 'Âdiyât, adiyat',
    index: 100,
    numberOfAyahs: 11,
  },
  {
    name: 'Kâriâ',
    page: 600,
    keywords: 'Kâriâ, kaaria',
    index: 101,
    numberOfAyahs: 11,
  },
  {
    name: 'Tekâsur',
    page: 600,
    keywords: 'Tekâsur, tekasür',
    index: 102,
    numberOfAyahs: 8,
  },
  {
    name: 'Asr',
    page: 601,
    keywords: 'Asr, asır',
    index: 103,
    numberOfAyahs: 3,
  },
  {
    name: 'Hûmeze',
    page: 601,
    keywords: 'Hûmeze, hümeze, humeze',
    index: 104,
    numberOfAyahs: 9,
  },
  {
    name: 'Fîl',
    page: 601,
    keywords: 'Fil, fîl',
    index: 105,
    numberOfAyahs: 5,
  },
  {
    name: 'Kureyş',
    page: 602,
    keywords: 'Kureyş, quraysh',
    index: 106,
    numberOfAyahs: 4,
  },
  {
    name: 'Mâûn',
    page: 602,
    keywords: 'Mâûn, maun',
    index: 107,
    numberOfAyahs: 7,
  },
  {
    name: 'Kevser',
    page: 602,
    keywords: 'Kevser',
    index: 108,
    numberOfAyahs: 3,
  },
  {
    name: 'Kâfirûn',
    page: 603,
    keywords: 'Kâfirûn, kafirun',
    index: 109,
    numberOfAyahs: 6,
  },
  { name: 'Nasr', page: 603, keywords: 'Nasr', index: 110, numberOfAyahs: 3 },
  {
    name: 'Tebbet',
    page: 603,
    keywords: 'Tebbet, leheb',
    index: 111,
    numberOfAyahs: 5,
  },
  {
    name: 'İhlas',
    page: 604,
    keywords: 'İhlas, ihlas, ıhlas, kulhu',
    index: 112,
    numberOfAyahs: 4,
  },
  { name: 'Felak', page: 604, keywords: 'Felak', index: 113, numberOfAyahs: 5 },
  { name: 'Nâs', page: 604, keywords: 'Nâs nas', index: 114, numberOfAyahs: 6 },
]

export default surahs
